import { Widget } from '../../../../../lib/Widget';
import { cssPrefix } from '../../../../../const/Constant';

class Divider extends Widget {

  constructor() {
    super(`${cssPrefix}-tools-divider`);
  }

}

export {
  Divider,
};
